export const inspecReportList =
{
    "inspection3Month": {
        "visitDate": null,
        "tenkenTimeFrom": null,
        "tenkenTimeTo": null,
        "deleverDate": null,
        "address": null,
        "customerCD": null,
        "customerName": null,
        "tenkenShiten": null,
        "tenkenTanto": null,
        "customerSign": null,
        "tantoSign": null,
        "yoyusyaHenso": "0",
        "syoyusya": "1",
        "confirmAdress": "",
        "confirmPhone": "",
        "affterAddress": "",
        "other": "",
        "honjitsuSagyo": "",
        "sagyocontent": "",
        "hokkaidoshiten": "0",
        "touhokushiten": "0",
        "kitakanntoshiten": "0",
        "tibashiten": "0",
        "toukyoushiten": "0",
        "yokohamashiten": "0",
        "nagoyashiten": "0",
        "kansaishiten": "0",
        "kyushushiten": "0",
        "azumaConstructure": "0",
        "bandoConstructure": "0",
        "kurodaHouse": "0"
    },
    "inspection6Month": {
        "visitDate": null,
        "tenkenTimeFrom": null,
        "tenkenTimeTo": null,
        "deleverDate": null,
        "address": null,
        "customerCD": null,
        "customerName": null,
        "tenkenShiten": null,
        "tenkenTanto": null,
        "customerSign": null,
        "tantoSign": null,
        "genkanKaihei": "0",
        "genkanPakkin": "0",
        "genkanKyuyu": "0",
        "barukoniKaihei": "0",
        "barukoniPakkin": "0",
        "barukoniKyuyu": "0",
        "suraidhingKaihei": "0",
        "suraidhingPakkin": "0",
        "suraidhinguKyuyu": "0",
        "windowKaihei": "0",
        "windowPakkin": "0",
        "windowKyuyu": "0",
        "commonSanho": "0",
        "commonMIzukiri": "0",
        "commonRyotan": "0",
        "naibuKaihei": "0",
        "naibuPakkin": "0",
        "naibuKyuyu": "0",
        "yokushituKigu": "0",
        "yokushituShiring": "0",
        "kittinKigu": "0",
        "kittinSonota": "0",
        "senmenKigu": "0",
        "senmenSonota": "0",
        "sentakuKigu": "0",
        "kankiFilter": "0",
        "kankiNetkoukan": "0",
        "kankiKanrei": "0",
        "kyokusyoFilter": "0",
        "reidanboEakon": "0",
        "reidanboKanrei": "0",
        "reidanboSuraimu": "0",
        "baibuKiso": "0",
        "baibuSyodobutu": "0",
        "honjitsuSagyo": "",
        "sagyocontent": "",
        "hokkaidoshiten": "0",
        "touhokushiten": "0",
        "kitakanntoshiten": "0",
        "tibashiten": "0",
        "toukyoushiten": "0",
        "yokohamashiten": "0",
        "nagoyashiten": "0",
        "kansaishiten": "0",
        "kyushushiten": "0",
        "azumaConstructure": "0",
        "bandoConstructure": "0",
        "kurodaHouse": "0"
    },
    "inspection12Month": {
        "visitDate": null,
        "tenkenTimeFrom": null,
        "tenkenTimeTo": null,
        "deleverDate": null,
        "address": null,
        "customerCD": null,
        "customerName": null,
        "tenkenShiten": null,
        "tenkenTanto": null,
        "customerSign": null,
        "tantoSign": null,
        "genkanKaihei": "0",
        "genkanPakkin": "0",
        "genkanKyuyu": "0",
        "barukoniKaihei": "0",
        "barukoniPakkin": "0",
        "barukoniKyuyu": "0",
        "suraidhingKaihei": "0",
        "suraidhingPakkin": "0",
        "suraidhinguKyuyu": "0",
        "windowKaihei": "0",
        "windowPakkin": "0",
        "windowKyuyu": "0",
        "commonSanho": "0",
        "commonMIzukiri": "0",
        "commonRyotan": "0",
        "naibuKaihei": "0",
        "naibuPakkin": "0",
        "naibuKyuyu": "0",
        "yokushituKigu": "0",
        "yokushituShiring": "0",
        "kittinKigu": "0",
        "kittinSonota": "0",
        "senmenKigu": "0",
        "senmenSonota": "0",
        "sentakuKigu": "0",
        "kankiFilter": "0",
        "kankiNetkoukan": "0",
        "kankiKanrei": "0",
        "kyokusyoFilter": "0",
        "reidanboEakon": "0",
        "reidanboKanrei": "0",
        "reidanboSuraimu": "0",
        "baibuKiso": "0",
        "baibuSyodobutu": "0",
        "honjitsuSagyo": "",
        "sagyocontent": "",
        "hokkaidoshiten": "0",
        "touhokushiten": "0",
        "kitakanntoshiten": "0",
        "tibashiten": "0",
        "toukyoushiten": "0",
        "yokohamashiten": "0",
        "nagoyashiten": "0",
        "kansaishiten": "0",
        "kyushushiten": "0",
        "azumaConstructure": "0",
        "bandoConstructure": "0",
        "kurodaHouse": "0"
    },
    "inspection24Month": {
        "visitDate": null,
        "tenkenTimeFrom": null,
        "tenkenTimeTo": null,
        "deleverDate": null,
        "address": null,
        "customerCD": null,
        "customerName": null,
        "tenkenShiten": null,
        "tenkenTanto": null,
        "customerSign": null,
        "tantoSign": null,
        "genkanKaihei": "0",
        "genkanPakkin": "0",
        "genkanKyuyu": "0",
        "barukoniKaihei": "0",
        "barukoniPakkin": "0",
        "barukoniKyuyu": "0",
        "suraidhingKaihei": "0",
        "suraidhingPakkin": "0",
        "suraidhinguKyuyu": "0",
        "windowKaihei": "0",
        "windowPakkin": "0",
        "windowKyuyu": "0",
        "commonSanho": "0",
        "commonMIzukiri": "0",
        "commonRyotan": "0",
        "naibuKaihei": "0",
        "naibuPakkin": "0",
        "naibuKyuyu": "0",
        "yokushituKigu": "0",
        "yokushituShiring": "0",
        "kittinKigu": "0",
        "kittinSonota": "0",
        "senmenKigu": "0",
        "senmenSonota": "0",
        "sentakuKigu": "0",
        "kankiFilter": "0",
        "kankiNetkoukan": "0",
        "kankiKanrei": "0",
        "kyokusyoFilter": "0",
        "reidanboEakon": "0",
        "reidanboKanrei": "0",
        "reidanboSuraimu": "0",
        "baibuKiso": "0",
        "baibuSyodobutu": "0",
        "honjitsuSagyo": "",
        "sagyocontent": "",
        "hokkaidoshiten": "0",
        "touhokushiten": "0",
        "kitakanntoshiten": "0",
        "tibashiten": "0",
        "toukyoushiten": "0",
        "yokohamashiten": "0",
        "nagoyashiten": "0",
        "kansaishiten": "0",
        "kyushushiten": "0",
        "azumaConstructure": "0",
        "bandoConstructure": "0",
        "kurodaHouse": "0"
    },
    "inspection4Year": {
        "visitDate": null,
        "tenkenTimeFrom": null,
        "tenkenTimeTo": null,
        "deleverDate": null,
        "address": null,
        "customerCD": null,
        "customerName": null,
        "tenkenShitenCD": null,
        "tenkenShiten": null,
        "tenkenTanto": null,
        "customerSign": null,
        "tantoSign": null,
        "kisoHudoTinka": "0",
        "kisoKiretu": "0",
        "kisoSonota": "0",
        "gaisoWare": "0",
        "gaisoToriaibu": "0",
        "gaisoJoint": "0",
        "gaihekiHenkei": "0",
        "gaihekiAmamizu": "0",
        "gaihekiSonota": "0",
        "barukoniRekka": "0",
        "barukoniTukiStatus": "0",
        "barukoniMokubu": "0",
        "yaneTakezai": "0",
        "yaneKabi": "0",
        "yaneNokisaki": "0",
        "flowerTorituke": "0",
        "flowerKanagu": "0",
        "flowerToriaibu": "0",
        "zenpanTateguSokumen": "0",
        "zenpanTateguSita": "0",
        "zenpanKanaguSabi": "0",
        "bousuiSanpo": "0",
        "bousuiSasikomi": "0",
        "bousuiRyoutan": "0",
        "barukoniComfirm": "0",
        "bousuiDanpaFuzu": "0",
        "bousuiDanpaYogore": "0",
        "bousuiDanpaSonota": "0",
        "honjitsuSagyo": "",
        "sagyocontent": "",
        "hokkaidoshiten": "0",
        "touhokushiten": "0",
        "kitakanntoshiten": "0",
        "tibashiten": "0",
        "toukyoushiten": "0",
        "yokohamashiten": "0",
        "nagoyashiten": "0",
        "kansaishiten": "0",
        "kyushushiten": "0",
        "azumaConstructure": "0",
        "bandoConstructure": "0",
        "kurodaHouse": "0"
    },
    "inspection7Year": {
        "visitDate": null,
        "tenkenTimeFrom": null,
        "tenkenTimeTo": null,
        "deleverDate": null,
        "address": null,
        "customerCD": null,
        "customerName": null,
        "tenkenShitenCD": null,
        "tenkenShiten": null,
        "tenkenTanto": null,
        "customerSign": null,
        "tantoSign": null,
        "kisoHudoTinka": "0",
        "kisoKiretu": "0",
        "kisoSonota": "0",
        "gaisoWare": "0",
        "gaisoJoint": "0",
        "gaisoToriaibu": "0",
        "gaihekiHenkei": "0",
        "gaihekiAmamizu": "0",
        "gaihekiSonota": "0",
        "barukoniRekka": "0",
        "barukoniTukiStatus": "0",
        "barukoniMokubu": "0",
        "yaneTakezai": "0",
        "yaneKabi": "0",
        "yaneNokisaki": "0",
        "flowerTorituke": "0",
        "flowerKanagu": "0",
        "flowerToriaibu": "0",
        "zenpanTateguSokumen": "0",
        "zenpanTateguSita": "0",
        "zenpanKanaguSabi": "0",
        "bousuiSanpo": "0",
        "bousuiSasikomi": "0",
        "bousuiRyoutan": "0",
        "bousuiDanpaFuzu": "0",
        "bousuiDanpaYogore": "0",
        "bousuiDanpaSonota": "0",
        "honjitsuSagyo": "",
        "sagyocontent": "",
        "hokkaidoshiten": "0",
        "touhokushiten": "0",
        "kitakanntoshiten": "0",
        "tibashiten": "0",
        "toukyoushiten": "0",
        "yokohamashiten": "0",
        "nagoyashiten": "0",
        "kansaishiten": "0",
        "kyushushiten": "0",
        "azumaConstructure": "0",
        "bandoConstructure": "0",
        "kurodaHouse": "0"
    },
    "inspection10Year": {
        "visitDate": null,
        "tenkenTimeFrom": null,
        "tenkenTimeTo": null,
        "deleverDate": null,
        "address": null,
        "customerCD": null,
        "customerName": null,
        "tenkenShitenCD": null,
        "tenkenShiten": null,
        "tenkenTanto": null,
        "customerSign": null,
        "tantoSign": null,
        "kisoHudoTinka": "0",
        "kisoKiretu": "0",
        "kisoSonota": "0",
        "gaisoWare": "0",
        "gaisoJoint": "0",
        "gaisoToriaibu": "0",
        "gaihekiHenkei": "0",
        "gaihekiAmamizu": "0",
        "gaihekiSonota": "0",
        "barukoniRekka": "0",
        "barukoniTukiStatus": "0",
        "barukoniMokubu": "0",
        "yaneTakezai": "0",
        "yaneKabi": "0",
        "yaneNokisaki": "0",
        "zenpanTateguSokumen": "0",
        "zenpanTateguSita": "0",
        "zenpanKanaguSabi": "0",
        "bousuiSanpo": "0",
        "bousuiSasikomi": "0",
        "bousuiRyoutan": "0",
        "naihekiHenkei": "0",
        "naihekiTawami": "0",
        "yukaHenkei": "0",
        "yukaHuroku": "0",
        "koyauraAmesome": "0",
        "koyauraDannetu": "0",
        "koyauraKouzo": "0",
        "yukasitaSitudo": "0",
        "yukasitaDannetuzai": "0",
        "yukasitaKouzouzai": "0",
        "yukaistaKiso": "0",
        "tikasituKabi": "0",
        "kutyoNetukoukan": "0",
        "kutyoKyokusyo": "0",
        "kutyoGaibu": "0",
        "siroariSyokugai": "0",
        "siroariUb": "0",
        "bousuiDanpaFuzu": "0",
        "bousuiDanpaYogore": "0",
        "kasaiKeihouKigen": "0",
        "genkanSirinder": "0",
        "genkanLockCase": "0",
        "genkanKurozer": "0",
        "haisuikanKittin": "0",
        "haisuikanYokushitsu": "0",
        "tenkenSyozi": "",
        "tenkenKanagu": "",
        "tenkenSyouzi": "",
        "tenkenSonota": "",
        "honjitsuSagyo": "",
        "sagyocontent": "",
        "hokkaidoshiten": "0",
        "touhokushiten": "0",
        "kitakanntoshiten": "0",
        "tibashiten": "0",
        "toukyoushiten": "0",
        "yokohamashiten": "0",
        "nagoyashiten": "0",
        "kansaishiten": "0",
        "kyushushiten": "0",
        "azumaConstructure": "0",
        "bandoConstructure": "0",
        "kurodaHouse": "0"
    }
}
